import createStore from './factory';

const identity = state => state;

// This is not an actual store
export class EmbedStore {
  static actions = {
    setName(global, state, name) {
      if (name === state.name) return state;
      return {...state, name};
    },
  }

  static equipment = {
    type: "equipment",
    name: "Equipment",
    class: "berserker",
    items: {},
  }
  static skills = {
    type: "skills",
    name: "Skills",
    class: "berserker",
    data: {},
  }
  static cards = {
    type: "cards",
    name: "Cards",
    cards: [],
  }
  static islands = {
    type: "islands",
    name: "Islands",
    islands: {},
  }
}

export const defaultBuilder = {
  class: "berserker",
  items: {},
  engravings: {},
  stats: {},
  skills: {},
  gems: [],
  cards: [],
  showPaperdoll: true,
  showStats: true,
  showEngravings: true,
  showSkills: true,
  showGems: true,
  showCards: true,
};

export default class RootStore extends createStore({
  addEmbed(state, embed) {
    if (typeof embed === "function") embed = embed(state);
    if (!embed) return state;
    embed = {...embed, id: 0};
    do {
      embed.id += 1;
    } while (state.embeds.find(e => e.id === embed.id));
    return {...state, embeds: [...state.embeds, embed], activeEmbed: state.embeds.length};
  },

  setEmbed(state, value) {
    const prev = state.embeds[state.activeEmbed];
    if (!prev) return state;
    if (typeof value === "function") value = value(prev, state);
    if (value === prev) return state;
    state = {...state, embeds: state.embeds.slice()};
    state.embeds[state.activeEmbed] = value;
    return state;
  },

  setActiveEmbed(state, id) {
    const index = state.embeds.findIndex(embed => embed.id === id);
    if (index === state.activeEmbed) return state;
    return {...state, activeEmbed: index};
  },

  renameEmbed(state, id, name) {
    const index = state.embeds.findIndex(embed => embed.id === id);
    if (index < 0 || state.embeds[index].name === name) return state;
    state = {...state};
    state.embeds = state.embeds.slice();
    state.embeds[index] = {...state.embeds[index], name};
    return state;
  },

  moveEmbed(state, from, to) {
    if (from === to) return state;
    state = {...state, embeds: state.embeds.slice()};
    const activeId = state.embeds[state.activeEmbed]?.id;
    const src = state.embeds.splice(from, 1);
    state.embeds.splice(to, 0, ...src);
    state.activeEmbed = state.embeds.findIndex(embed => embed.id === activeId);
    return state;
  },

  deleteEmbed(state, id) {
    const index = state.embeds.findIndex(embed => embed.id === id);
    if (index < 0) return state;
    state = {...state};
    state.embeds = state.embeds.slice();
    state.embeds.splice(index, 1);
    if (state.activeEmbed >= state.embeds.length) {
      state.activeEmbed = state.embeds.length - 1;
    }
    return state;
  },

  setState(state, value) {
    if (typeof value === "function") value = value(state);
    value = {...value};
    if (!value.embeds[value.activeEmbed]) {
      value.activeEmbed = -1;
    }
    return value;
  },

  setName(state, name) {
    if (name === state.name) return state;
    return {...state, name};
  },

  setBuilder(state, value) {
    if (typeof value === "function") value = value(state.builder || defaultBuilder);
    if (value === state.builder) return state;
    return {...state, builder: value};
  },
}, {
  id: 0,
  embeds: [],
  activeEmbed: -1,
}) {
  static uniqueId = 1;
  static newId() {
    return ++RootStore.uniqueId;
  }

  constructor(initialState) {
    super(initialState);
    this.dispatch.embed = {};
    for (const action in EmbedStore.actions) {
      this.dispatch.embed[action] = (...args) => this.dispatch.setEmbed((embed, state) => EmbedStore.actions[action](state, embed, ...args));
    }
  }

  getEmbed() {
    const state = this.getState();
    return state.embeds[state.activeEmbed];
  }

  setState(value) {
    return new Promise((resolve, reject) => {
      let unsubscribe;
      const handler = () => {
        unsubscribe();
        resolve();
      };
      unsubscribe = this.store.subscribe(handler);
      this.dispatch.setState(value);
    });
  }

  static useEmbed(func, depends) {
    func = func || identity;
    return this.useSelector(state => {
      const embed = state.embeds[state.activeEmbed];
      return func(embed);
    }, depends);
  }

  static useBuilder(func, depends) {
    func = func || identity;
    return this.useSelector(state => func(state.builder || defaultBuilder), depends);
  }
}

RootStore.instance = new RootStore();
